import React from 'react';

const NotificationsSection = ({ settings, onChange }) => {
  const anyEmailEnabled =
    settings['notifications.emailOnFailure'] ||
    settings['notifications.emailOnCompletion'] ||
    settings['notifications.dailySummary'];

  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <i className="bi bi-bell" />
        Notifications
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Email on Sync Failure</span>
          <span className="settings-row-help">Send an email when a sync operation fails</span>
        </div>
        <div className="settings-row-control">
          <button
            className={`settings-toggle${settings['notifications.emailOnFailure'] ? ' active' : ''}`}
            onClick={() => onChange('notifications.emailOnFailure', !settings['notifications.emailOnFailure'])}
            aria-label="Toggle email on failure"
          >
            <span className="settings-toggle-knob" />
          </button>
        </div>
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Email on Sync Completion</span>
          <span className="settings-row-help">Send an email when a sync completes successfully</span>
        </div>
        <div className="settings-row-control">
          <button
            className={`settings-toggle${settings['notifications.emailOnCompletion'] ? ' active' : ''}`}
            onClick={() => onChange('notifications.emailOnCompletion', !settings['notifications.emailOnCompletion'])}
            aria-label="Toggle email on completion"
          >
            <span className="settings-toggle-knob" />
          </button>
        </div>
      </div>

      <div className="settings-row">
        <div className="settings-row-info">
          <span className="settings-row-label">Daily Summary Email</span>
          <span className="settings-row-help">Send a daily digest of sync activity</span>
        </div>
        <div className="settings-row-control">
          <button
            className={`settings-toggle${settings['notifications.dailySummary'] ? ' active' : ''}`}
            onClick={() => onChange('notifications.dailySummary', !settings['notifications.dailySummary'])}
            aria-label="Toggle daily summary"
          >
            <span className="settings-toggle-knob" />
          </button>
        </div>
      </div>

      {settings['notifications.dailySummary'] && (
        <div className="settings-row">
          <div className="settings-row-info">
            <span className="settings-row-label">Summary Time</span>
            <span className="settings-row-help">Time to send the daily summary (IST)</span>
          </div>
          <div className="settings-row-control">
            <input
              type="time"
              className="settings-time-input"
              value={settings['notifications.dailySummaryTime'] ?? '09:00'}
              onChange={e => onChange('notifications.dailySummaryTime', e.target.value)}
            />
          </div>
        </div>
      )}

      {anyEmailEnabled && (
        <>
          <div className="settings-row">
            <div className="settings-row-info">
              <span className="settings-row-label">Recipient Email</span>
              <span className="settings-row-help">Email address to receive notifications</span>
            </div>
            <div className="settings-row-control">
              <input
                type="email"
                className="settings-text-input"
                placeholder="admin@example.com"
                value={settings['notifications.recipientEmail'] ?? ''}
                onChange={e => onChange('notifications.recipientEmail', e.target.value)}
              />
            </div>
          </div>

          <div className="settings-row">
            <div className="settings-row-info">
              <span className="settings-row-label">Email Cooldown</span>
              <span className="settings-row-help">Minimum minutes between notification emails to prevent spam</span>
            </div>
            <div className="settings-row-control">
              <input
                type="number"
                className="settings-number-input"
                min={1}
                max={60}
                value={settings['notifications.emailCooldownMinutes'] ?? 5}
                onChange={e => onChange('notifications.emailCooldownMinutes', Math.min(60, Math.max(1, Number(e.target.value))))}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NotificationsSection;
